<template>
  <div class="upload">
    <el-upload class="avatar-uploader" 
      :accept="accept" 
      :show-file-list="true"
      :action="uploadUrl"       
      multiple
      :before-upload="beforeAvatarUpload" 
      :on-success="handleAvatarSuccess" 
      :http-request="upload" 
      v-loading="loading" 
      element-loading-text="正在上传" 
      element-loading-spinner="el-icon-loading" 
      element-loading-background="rgba(0, 0, 0, 0.8)">
      <div class="uploaded-wrap" v-if="imageUrl">
        <img :src="imageUrl" class="avatar" v-if="type=='image'">
        <span class="el-icon-service" v-if="type=='audio'"></span>
        <span class="el-icon-caret-right" v-if="type=='video'"></span>
        <span class="el-icon-goods" v-if="type=='apk'"></span>
        <div class="btn-wrap" v-if="type!=='apk'">
          <el-button icon="el-icon-zoom-in" size="mini" circle @click.stop="preview"></el-button>
        </div>
      </div>
      <i v-else class="el-icon-upload avatar-uploader-icon"></i>
    </el-upload>
    <el-dialog append-to-body :visible.sync="dialogVisible" title="预览">
      <img width="100%" :src="imageUrl" alt="" v-if="type=='image'">
      <audio width="100%" :src="imageUrl" v-if="type=='audio'" controls></audio>
      <video width="100%" v-if="type==='video'" :src="imageUrl" controls></video>
    </el-dialog>
  </div>
</template>
<script>
import { formatDate } from '@/utils'
import ImageCompressor from 'image-compressor.js'
import Cookies from 'js-cookie'
import TcVod from 'vod-js-sdk-v6'
const compress = new ImageCompressor()
/* eslint-disable */
export default {
  data () {
    return {
      uploadUrl: '',
      loading: false,
      dialogVisible: false,
      i: 0
    }
  },
  props: {
    value: {
      type: String,
      defaul: ''
    },
    type: {
      type: String,
      default: 'image'
    },
    imgOptions: {
      type: Object,
      default () {
        return {
          size: 20, // the max size in MB, defaults to 2MB
          quality: 1, // the quality of the image, max is 1,
          maxWidth: Infinity, // the max width of the output image, defaults to 1920px
          maxHeight: Infinity, // the max height of the output image, defaults to 1920px
          resize: true // defaults to true, set false if you do not want to resize the image width and height
        }
      }
    },
    width: {
      type: [Number, String],
      default () {
        return null
      }
    },
    height: {
      type: [Number, String],
      default () {
        return null
      }
    },
    CDN: {
      type: String,
      default: 'https://fdomsimage.oss-cn-huhehaote.aliyuncs.com/'
    },
    path: {
      type: String,
      default: 'image/specialtopic/'
    },
    accept: {
      type: String,
      default: 'image/*'
    },
    mode: {
      type: String,
      default: ''
    },
    signature: {
      type: String,
      default: ''
    },
    currentIdx: {
      type: Number,
      default: 0
    }
  },
  computed: {
    imageUrl () {
      return this.value
    }
  },
  methods: {
    preview () {
      this.dialogVisible = true
    },
    async upload (option) {
      if (this.mode === 'tencentCloud') {
        this.loading = true
        const tcVod = new TcVod({
          getSignature: () => {
            return this.signature
          } // 前文中所述的获取上传签名的函数
        })
        const uploader = tcVod.upload({
          mediaFile: option.file // 媒体文件（视频或音频或图片），类型为 File
        })
        await uploader.on('media_progress', (info) => {
          // console.log(info.percent) // 进度
        })
        await uploader.done().then((res) => {
          this.loading = false
          const _temp = res
          _temp.fileName = option.file.name
          this.$emit('addFiles', {
            idx: this.currentIdx,
            id: _temp && _temp.fileId || '',
            videoFile: _temp && _temp.video && _temp.video.url || '',
            fileType: 1,
            fileName: _temp && _temp.fileName || ''
          })
          this.$emit('input', _temp && _temp.video && _temp.video.url || '')
          // option.onSuccess(_temp)
          // return _temp
        // deal with doneResult
        }).catch((err) => {
          this.loading = false
          option.onError('上传失败')
        })
      } else {

        let ret
        let relativePath = this.path
        // console.log(Cookies.getJSON('user'))
        let uploadConfig = Cookies.getJSON('user').uploadConfig
      console.log(this.mode,option,uploadConfig,1111);

        // 分片上传文件
        let client = new OSS({
          secure: true,
          accessKeyId: uploadConfig.accessKeyId,
          accessKeySecret: uploadConfig.accessKeySecret,
          bucket: uploadConfig.bucketName,
          endpoint: uploadConfig.endpoint
        })
        this.loading = true
        // console.log(option)
        // console.log(option.file.name)
        if (this.type === 'image') {
          const imgsArr = ['png', 'jpg', 'jpeg']
          const lastIndex = option.file.name.lastIndexOf('.')
          const suffix = option.file.name.substr(lastIndex + 1)
          if (imgsArr.indexOf(suffix) > -1) {
            try {
              const size = option.file.size / (1024 * 1024)
              if (size <= 0.8) {
                this.imgOptions.quality = 1
                this.imgOptions.maxWidth = Infinity
                this.imgOptions.maxHeight = Infinity
              }
              // this.imgOptions.width = this.width
              // this.imgOptions.height = this.height
              let result = await compress.compress(option.file, this.imgOptions)
              // console.log(result)
              ret = await client.multipartUpload(relativePath + formatDate(new Date(), 'yyyyMMddhhmmss'), result, {
                progress: async function (p) {
                  let e = {}
                  e.percent = p * 100
                  option.onProgress(e)
                }
              })
            } catch (err) {
              console.log(err)
            }
          } else {
            this.loading = false
            this.$message({
              message: '只能上传png,jpg格式的图片',
              duration: 2000,
              type: 'error'
            })
          }
        } else if (this.type === 'apk') {
          let { name } = option.file
          name = name.split('.')[1]
          if (name !== 'apk') {
            this.$message({
              message: '只能上传apk类型的文件',
              duration: 2000,
              type: 'error'
            })
            this.loading = false
          } else {
            try {
              client.options.bucket = 'fdapprelease'
              ret = await client.multipartUpload(relativePath + formatDate(new Date(), 'yyyyMMddhhmmss'), option.file, {
                progress: async function (p) {
                  let e = {}
                  e.percent = p * 100
                  option.onProgress(e)
                },
                partSize: 1000 * 1024, // 设置分片大小
                timeout: 120000 // 设置超时时间
              })
            } catch (e) {
              console.log(e)
            }
          }
        } else {
          // console.log('other', option.file, relativePath + formatDate(new Date(), 'yyyyMMddhhmmss'));
          // return false
          this.i++
          try {
            ret = await client.multipartUpload(relativePath + formatDate(new Date(), 'yyyyMMddhhmmss') + this.i, option.file, {
              progress: async function (p) {
                let e = {}
                e.percent = p * 100
                option.onProgress(e)
              }
            })
          } catch (e) {
            console.log(e)
          }
        }
        if (ret.res.statusCode === 200) {
          option.onSuccess(ret)
          return ret
        } else {
          option.onError('上传失败')
        }
      }
    },
    beforeAvatarUpload (file) {
      let _this = this
      if (_this.width !== null && _this.height !== null) {
        const isSize = new Promise((resolve, reject) => {
          let _URL = window.URL && window.webkitURL
          let img = new Image()
          img.onload = function () {
            let valid = img.width === parseInt(_this.width) && img.height === parseInt(_this.height)
            valid ? resolve() : reject()
          }
          img.src = _URL.createObjectURL(file)
        }).then(() => {
          return file
        }, () => {
          _this.$message({
            message: `图片宽高只能为${_this.width}*${_this.height}`,
            duration: 2000,
            type: 'error'
          })
          return Promise.reject()
        })
        return isSize
      }
    },
    handleAvatarSuccess (res, file) {
      this.loading = false
      if (this.mode !== 'tencentCloud') {
        let url = this.CDN + res.name
        this.$emit('addFiles', {
          id: "",
          videoFile: url,
          fileType: this.type == 'audio' ? 1 : 2,
          videoFileOrder: 0,
          videoFileName: file.name.split('.')[0]
        })
        this.$emit('input', url)
      }
      // if (this.mode === 'tencentCloud') {
      //   this.$emit('addFiles', {
      //     idx: this.currentIdx,
      //     id: res && res.fileId || '',
      //     videoFile: res && res.video && res.video.url || '',
      //     fileType: 1,
      //     fileName: res && res.fileName || ''
      //   })
      //   this.$emit('input', res && res.video && res.video.url || '')
      // } else {
      //   let url = this.CDN + res.name
      //   this.$emit('addFiles', {
      //     id: "",
      //     videoFile: url,
      //     fileType: this.type == 'audio' ? 1 : 2,
      //     videoFileOrder: 0,
      //     videoFileName: file.name.split('.')[0]
      //   })
      //   this.$emit('input', url)
      // }
    }
  }
}
</script>
<style lang="scss" scoped>
.upload /deep/ {
  overflow: hidden;
  .avatar-uploader {
    width: 180px;
    height: 180px;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    .el-upload {
      cursor: pointer;
      position: relative;
      overflow: hidden;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      .el-icon-upload,
      .el-icon-service,
      .el-icon-goods,
      .el-icon-caret-right {
        font-size: 40px;
      }
      .btn-wrap {
        position: absolute;
        z-index: 100;
        top: 5px;
        right: 5px;
        line-height: 1;
      }
      &:hover {
        border-color: $color-primary;
      }
    }
    .el-icon-service,
    .el-icon-goods,
    .el-icon-caret-right {
      color: $color-primary;
    }
    .el-icon-caret-right {
      border: 1px solid $color-primary;
      perspective: 3d;
      border-radius: 50%;
      width: 40px;
      height: 40px;
      overflow: hidden;
    }
    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 178px;
      height: 178px;
      line-height: 178px;
      text-align: center;
    }
    .uploaded-wrap {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        display: block;
      }
      audio {
        width: 100%;
        display: block;
      }
    }
    .avatar {
      width: 178px;
      height: 178px;
      display: block;
    }
  }
  .el-dialog__body {
    padding: 0 20px 20px;
    text-align: center;
    img {
      display: block;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/upload.vue